interface Array<T> {
  head(): T;
  tail() : T;
  first() : T;
  firstOrDefault(defaultValue: T) : T;
  last() : T;
  distinct() : Array<T>;
  flatten() : Array<T>;
  flatMap<R>(mapper:(element:T, index?: number, array?: Array<T>) => Array<R> ): Array<R>;
  sortBy<R>(mapper:(element:T) => R ): Array<T>;
  min(): T;
  max(): T;
  min<R>(mapper:(element:T) => R ): T;
  max<R>(mapper:(element:T) => R ): T;
  removeFirst(value:T) : Array<T>;
  pushAll(value:Array<T>) : Array<T>;
  unique() : Array<T>;
  diff(value:Array<T>) : Array<T>;
  getById(id: string) : T;
  getByField(value: any, field: string) : T;
}

interface String {
  toCamelCase();
  replaceAt(index: number, char: string);
  reverse();
}

interface Date {
  compare(x:Date):number;
}

Date.prototype.compare =  function(x){
  var result = this.getTime() - x.getTime();
  return result;
};

class Dictionary<T>{
  [index: string]: T;
}

class Helpers {
  static range(start:number, end :number = -1, step:number = 1){
    if(end < 0){
      end = start;
      start = 0;
    }
    var result = [];
    for(var i = start; i < end; i += step) {
      result.push(i);
    }
    return result;
  }
  static clone(obj) : any {
    return Object.keys(obj).reduce((prev, cur) => {
      prev[cur] = obj[cur];
      return prev;
    }, {});
  }

  static cloneStringElements(obj) : any {
    return Object.keys(obj).reduce((prev, cur) => {
      if(typeof obj[cur] === 'string') {
        prev[cur] = obj[cur];
      }
      return prev;
    }, {});
  }

  static cloneSpecificStringElements(obj, list:Array<string>) : any {
    return Object.keys(obj).reduce((prev, cur) => {
      if(typeof obj[cur] === 'string' && list.indexOf(cur)!==-1) {
        prev[cur] = obj[cur];
      }
      return prev;
    }, {});
  }
}

Array.prototype.sortBy = function(getterFunc){
  var getter = x => x;
  if(getterFunc){
    getter = getterFunc;
  }
  return this.sort((x, y) => {
    var valX = getter(x);
    var valY = getter(y);
    if(valX > valY){
      return 1;
    }
    if(valX == valY){
      return 0;
    }
    if( valX < valY){
      return -1;
    }
  });
};

Array.prototype.min = function(){
  var getter = x => x;
  return this.sortBy(getter).first();
};

Array.prototype.pushAll= function(values) {
  values.forEach(x => this.push(x));
  return this;
};

Array.prototype.max = function(){
  var getter = x => x;
  return this.sortBy(getter).last();
};


Array.prototype.head = function(){
  if(this.length <= 1)
  {
    return this;
  }
  this.reverse();
  var result = this.slice(1);
  result.reverse();
  return result;
};

Array.prototype.tail = function(){
  if(this.length <= 1)
  {
    return this;
  }
  return this.slice(1);
};

Array.prototype.firstOrDefault = function(defaultValue){
  return typeof this[0] == 'undefined' ? defaultValue : this[0];
};

Array.prototype.first = function(){
  return this[0];
};

Array.prototype.last = function(){
  return this[this.length-1];
};

Array.prototype.distinct = function(){
  return this.reduce( (result, next) => result.indexOf(next) < 0 ? result.concat([next]) : result, []);
};

Array.prototype.flatten = function(){
  return this.reduce(function(result, next){
    return result.concat(next);
  }, []);
};

Array.prototype.flatMap = function(func: (value: any, index?: number, array?: any[]) => any[]) {
  var results: any[] = [];
  this.forEach((x, y, z) => {
    var temp = func(x, y, z);
    results = results.concat(temp);
  });
  return results;
};

Array.prototype.removeFirst = function(value){
  var index = this.indexOf(value);
  if(index > -1) {
    this.splice(index, 1);
  }
  return this;
};

Array.prototype.unique = function(){
  var hash = {}, result = [];
  this.forEach(item=>{
    if(!hash.hasOwnProperty(item)) {
      hash[item] = true;
      result.push(item);
    }
  });
  return result;
}

Array.prototype.diff = function(array_to_compare) {
    return this.filter(function(el) { return array_to_compare.indexOf(el) < 0; });
};

Array.prototype.getById = function(id) {
  var result = this.filter(x => x.id == id);
  console.log(result);
  return result.length == 1 ? result.first() : null;
}

Array.prototype.getByField = function(value, field) {
  var result = this.filter(x => x[field] == value);
  return result.length == 1 ? result.first() : null;
}

String.prototype.replaceAt = function(index:number, character:string) {
    return this.substr(0, index) + character + this.substr(index+character.length);
}

String.prototype.toCamelCase = function() {
    return this.replace(/^([A-Z])|[\s-_](\w)/g, function(match, p1, p2, offset) {
        if (p2) return p2.toUpperCase();
        return p1.toLowerCase();
    });
};

String.prototype.reverse = function() {
    return this.split('').reverse().join('');
};
